'use client';

import cx from 'classix';
import { useState } from 'react';

import rootPageSharedStyles from '@/app/[locale]/root-page-share.module.scss';
import Banner from '@/features/global-search-banner/components/banner/banner';
import SearchSlider from '@/features/global-search-banner/components/search-slider/search-slider';
import CreateListing from '@/features/listing/components/create-listing/create-listing';
import { type Place } from '@/features/place/types/place-types';

import styles from './home-intro-section.module.scss';

export interface HomeIntroStat {
  label: string;
  /** Already formatted for display ("17,140"), so the client never formats numbers. */
  value: string;
}

interface HomeIntroSectionProps {
  lastSearchedPlaces: Place[] | null;
  place: Place | null;
  /** Live inventory lines under the heading; empty when the count is unavailable. */
  stats: HomeIntroStat[];
  subtitle: string;
  title: string;
}

// The heading and subtitle arrive as strings from the server page, which is
// where the locale is known. Until 2026-09-23 they followed the service-type
// cookie ("Rooms for rent" / "Roommates" / "Tenants"...), so the H1 of the
// most-crawled URL on the site depended on what the visitor last clicked.
export default function HomeIntroSection(props: HomeIntroSectionProps) {
  const {
    lastSearchedPlaces,
    place,
    stats,
    subtitle,
    title,
  } = props;

  const [showServiceType,
    setShowServiceType] = useState<boolean>(false);

  return (
    <div className={cx(rootPageSharedStyles.section, styles.homeIntroSection)}>
      <div className={styles.homeIntroSection_content}>
        <div className={styles.homeIntroSection_search}>
          <div className={styles.homeIntroSection_wrapper}>
            <h1>{title}</h1>
            <p>{subtitle}</p>

            {stats.length > 0 && (
              <ul className={styles.homeIntroSection_stats}>
                {stats.map((stat) => (
                  <li key={stat.label}>
                    <strong>{stat.value}</strong>
                    {' '}
                    {stat.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <SearchSlider
            showServiceType={showServiceType}
            setShowServiceType={setShowServiceType}
            place={place}
            lastSearchedPlaces={lastSearchedPlaces}
          />
        </div>

        <Banner />
      </div>

      <CreateListing />
    </div>
  );
}
